import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterString',
    standalone: false
})
export class FilterStringPipe implements PipeTransform {
    transform(items: any[], args: any): any {
        return items.filter((item) => item !== args);
    }
}
